import { cn } from "@cobrastyle/ui";
import { formatPrice } from "@/lib/format-price";

interface PriceLabelProps {
  price: number;
  originalPrice?: number;
  currency?: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const priceSizes = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-2xl",
  xl: "text-3xl",
};

const originalPriceSizes = {
  sm: "text-sm",
  md: "text-sm",
  lg: "text-lg",
  xl: "text-xl",
};

// Like @cobrastyle/ui's <Price>, but in --color-price (the canvas's olive
// price color) instead of a hardcoded text-foreground the package doesn't
// expose an override for. The figure itself comes from lib/format-price, the
// one formatter — a suggestion in the search dropdown and the card it leads to
// must not disagree about a price.
export function PriceLabel({
  price,
  originalPrice,
  currency = "SEK",
  size = "md",
  className,
}: PriceLabelProps) {
  const hasDiscount = originalPrice !== undefined && originalPrice > price;

  return (
    <span className={cn("inline-flex min-w-0 flex-wrap items-center gap-x-2 gap-y-0.5", className)}>
      <span className={cn("font-semibold text-price", priceSizes[size])}>
        {formatPrice(price, currency)}
      </span>
      {hasDiscount && (
        <span className={cn("text-muted line-through", originalPriceSizes[size])}>
          {formatPrice(originalPrice, currency)}
        </span>
      )}
    </span>
  );
}
